import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { AAMSGameDataEffect } from "./src/aams-game-data.effect";
import { aamsGameDataReducer } from "./src/aams-game-data.reducer";

const EFFECTS = [AAMSGameDataEffect];

@NgModule({
	imports: [
		StoreModule.forFeature("gamingAamsGameData", {
			aamsGameData: aamsGameDataReducer,
		}),
		EffectsModule.forFeature(EFFECTS),
	],
})
export class AamsGameDataModule {}
